import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { AuthService } from 'app/core/auth/auth.service';
import {
    defaultGlobalAdminNavigation,
    defaultMandatNavigation,
} from 'app/mock-api/common/navigation/data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService, private _authService: AuthService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    private determineNavigationItems(): FuseNavigationItem[] {
        if (this._authService.isUserGlobalAdmin && (this._authService.currentMandat == null || this._authService.currentMandat == undefined)) {
            return defaultGlobalAdminNavigation;
        }

        return defaultMandatNavigation;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService.onGet('api/common/navigation').reply(() => {
            const defaultNavigation = this.determineNavigationItems();

            // Fill compact navigation children using the default navigation
            defaultNavigation.forEach((compactNavItem) => {
                defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === compactNavItem.id) {
                        compactNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            // Fill futuristic navigation children using the default navigation
            defaultNavigation.forEach((futuristicNavItem) => {
                defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === futuristicNavItem.id) {
                        futuristicNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            // Fill horizontal navigation children using the default navigation
            defaultNavigation.forEach((horizontalNavItem) => {
                defaultNavigation.forEach((defaultNavItem) => {
                    if (defaultNavItem.id === horizontalNavItem.id) {
                        horizontalNavItem.children = cloneDeep(
                            defaultNavItem.children
                        );
                    }
                });
            });

            // Return the response
            return [
                200,
                {
                    compact: cloneDeep(defaultNavigation),
                    default: cloneDeep(defaultNavigation),
                    futuristic: cloneDeep(defaultNavigation),
                    horizontal: cloneDeep(defaultNavigation),
                },
            ];
        });
    }
}
